import { Modal } from "react-bootstrap";
import { Wrapper, Button, Refund } from "../styles";
import { convertDate, hasReturnWindowExpired } from "../utils";
import { downloadReturnLabel } from "../api/order";
import toast from "react-hot-toast";

const fallbackStatusSteps = (returnObj) => {
  const products = returnObj.products || [];
  const hasRefund = products.some((product) => product.returnType === "Refund");
  const hasExchange = products.some((product) => product.returnType === "Exchange");

  let step4 = {
    statusId: "refund-initiated",
    statusLabel: "Refund Initiated",
  };

  if (hasExchange && !hasRefund) {
    step4 = {
      statusId: "exchange-shipped",
      statusLabel: "Exchange Item Shipped",
    };
  }

  if (hasRefund && hasExchange) {
    step4 = {
      statusId: "refund-initiated-exchange-shipped",
      statusLabel: "Refund Initiated & Exchange Item Shipped",
    };
  }

  return {
    step1: {
      statusId: "return-started",
      statusLabel: "Return Started",
    },
    step2: {
      statusId: "label-created",
      statusLabel: "Label Created",
    },
    step3: {
      statusId: "item-received",
      statusLabel: "Item Received",
    },
    step4,
  };
};

export const ViewReturnsTemplate = ({ currentOrder }) => {
  let returnTotal = 0;

  const renderReturns = () => {
    return currentOrder?.returns.map((returnObj) => {
      returnTotal = returnTotal + returnObj.refundAmount;
      return (
        <Refund className="view-returns-template" key={returnObj._id}>
          {renderProducts(returnObj)}
        </Refund>
      );
    });
  };

  const getLabel = async (label) => {
    try {
      const url = await downloadReturnLabel(label);
      if (url) {
        window.open(url, "_blank");
      } else {
        toast.error("Couldn't find return label.");
      }
    } catch (err) {
      toast.error(err.message);
      console.log(err);
    }
  };

  const getReturnSteps = (returnObj) => returnObj.statusSteps || fallbackStatusSteps(returnObj);

  const renderReturnTimeline = (returnObj) => {
    const currentStatus = returnObj.currentStatus || "step1";
    const currentIndex = Number(currentStatus.replace("step", ""));
    const steps = getReturnSteps(returnObj);

    return (
      <div className="return-status-timeline">
        {Object.keys(steps).map((stepKey, index) => {
          const step = steps[stepKey];
          const isActive = index + 1 <= currentIndex;
          return (
            <div className={`return-status-step ${isActive ? "active" : ""}`} key={stepKey}>
              <div className="return-status-top-row">
                <span className="return-status-line" />
                <span className="return-status-circle" />
                <span className="return-status-line" />
              </div>
              <span className="return-status-label">{step.statusLabel}</span>
            </div>
          );
        })}
      </div>
    );
  };

  const renderProducts = (returnObj) => {
    console.log("bobtest", returnObj);
    const returnWindowExpired = hasReturnWindowExpired(currentOrder.updatedAt);

    const filteredProducts = returnObj.products.filter((product) => {
      return product.returnType !== "Keep";
    });
    const products = filteredProducts.map((product) => {
      return (
        <div className="product-row" key={product.itemId}>
          <div className="product-image">
            <picture>
              <source srcSet={product.thumbnail} type="image/avif" />
              <img src={product.thumbnail} width="140" />
            </picture>
          </div>
          <div className="product-block">
            <h2>{product.productName}</h2>
            <div className="product-block-row">
              <span className="product-block-label">Return Type</span>
              <strong className="product-block-value">{product.returnType}</strong>
            </div>
            <div className="product-block-row">
              <span className="product-block-label">Original Size</span>
              <strong className="product-block-value">{product.size}</strong>
            </div>
            <div className="product-block-row">
              {product.returnType === "Refund" ? (
                <>
                  <span className="product-block-label">Item Cost</span>
                  <strong className="product-block-value">${(product.productCost / 100).toFixed(2)}</strong>
                </>
              ) : (
                <>
                  <span className="product-block-label">Exchange Size</span>
                  <strong className="product-block-value">{product.sizeExchange}</strong>
                </>
              )}
            </div>
          </div>
        </div>
      );
    });
    return (
      <>
        {renderReturnTimeline(returnObj)}
        <div className="return-products">{products}</div>
        <div className="return-details">
          <div>
            Return Date
            <br />
            <span>{convertDate(returnObj.createdAt)}</span>
          </div>
          {returnObj.totalSalesTaxRefund > 0 && (
            <div>
              + Sales Tax Refund
              <br />
              <span>${(returnObj.totalSalesTaxRefund / 100).toFixed(2)}</span>
            </div>
          )}
          {returnObj.shippingFee > 0 && (
            <div>
              - Return Shipping Fee
              <br />
              <span>${(returnObj.shippingFee / 100).toFixed(2)}</span>
            </div>
          )}
          {returnObj.refundAmount > 0 && (
            <div>
              = Refund Amount
              <br />
              <span>${(returnObj.refundAmount / 100).toFixed(2)}</span>
            </div>
          )}
          {returnObj.currentStatus === "step2" && !returnWindowExpired && (
            <div className="return-label">
              <Button onClick={() => getLabel(returnObj.returnLabel)} className="small grey">
                Return Label
              </Button>
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <Wrapper className="modal-styles withPadding return-view">
      <Modal.Header closeButton>
        <Modal.Title>Order # {currentOrder.orderNumber}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{renderReturns()}</div>
        {returnTotal > 0 && (
          <>
            <div className="return-bottom-bar">
              <span className="text">Total Refund Amount for this Order</span>
              <span className="amount">${(returnTotal / 100).toFixed(2)}</span>
            </div>
            <p style={{ marginTop: "20px", fontStyle: "italic", padding: "0 20px", textAlign: "center" }}>
              <strong>1 Free Return Per Order</strong>
              <br />
              One free return allowed per order. Additional returns are subject to a shipping fee.
            </p>
          </>
        )}
      </Modal.Body>
    </Wrapper>
  );
};
